
<mat-dialog-content [ngStyle]="{'text-align': messages.length > 1 ? 'left' : 'center' }" >
  <h3 style="font-weight: 500" *ngIf="data.header_msg" >{{data.header_msg}}</h3>
  <p *ngFor="let msg of messages" >{{msg}}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-flat-button mat-dialog-close>{{data.cancel_action}}</button>
  <button mat-flat-button color="warn" [mat-dialog-close]="true" cdkFocusInitial>{{data.ok_action}}</button>
</mat-dialog-actions>
